import React, { useState, useMemo } from "react";

// ---------------- SAMPLE PRODUCT DATA ----------------
// Replace with your real data from API or static JSON
export const productsData = [
  {
    id: "L001",
    title: "22K Gold Locket Floral Design",
    category: "Gold Locket",
    purity: "22K",
    price: 18500,
    weight: 4.2,
    image: "https://via.placeholder.com/300x300?text=Locket+1",
  },
  {
    id: "L002",
    title: "Diamond Locket Premium",
    category: "Diamond Locket",
    purity: "18K",
    price: 42000,
    weight: 3.8,
    image: "https://via.placeholder.com/300x300?text=Locket+2",
  },
  {
    id: "L003",
    title: "Antique Gold Locket",
    category: "Antique Locket",
    purity: "22K",
    price: 29500,
    weight: 6.1,
    image: "https://via.placeholder.com/300x300?text=Locket+3",
  },
];

// ---------------- MAIN FILTER COMPONENT ----------------
export default function LocketFilterPage() {
  const [searchText, setSearchText] = useState("");
  const [category, setCategory] = useState("All");
  const [purity, setPurity] = useState("All");
  const [priceRange, setPriceRange] = useState([0, 50000]);

  const filteredProducts = useMemo(() => {
    return productsData.filter((p) => {
      return (
        (category === "All" || p.category === category) &&
        (purity === "All" || p.purity === purity) &&
        p.price >= priceRange[0] &&
        p.price <= priceRange[1] &&
        p.title.toLowerCase().includes(searchText.toLowerCase())
      );
    });
  }, [searchText, category, purity, priceRange]);

  return (
    <div className="max-w-7xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Locket Collection</h1>

      {/* ---------------- FILTER SECTION ---------------- */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
        {/* Search */}
        <input
          type="text"
          placeholder="Search Locket..."
          className="border p-2 rounded"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />

        {/* Category Filter */}
        <select
          className="border p-2 rounded"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          <option value="All">All Categories</option>
          <option value="Gold Locket">Gold Locket</option>
          <option value="Diamond Locket">Diamond Locket</option>
          <option value="Antique Locket">Antique Locket</option>
        </select>

        {/* Purity Filter */}
        <select
          className="border p-2 rounded"
          value={purity}
          onChange={(e) => setPurity(e.target.value)}
        >
          <option value="All">All Purity</option>
          <option value="22K">22K</option>
          <option value="18K">18K</option>
        </select>

        {/* Price Filter */}
        <select
          className="border p-2 rounded"
          value={priceRange.join("-")}
          onChange={(e) => {
            const [min, max] = e.target.value.split("-").map(Number);
            setPriceRange([min, max]);
          }}
        >
          <option value="0-50000">All Price</option>
          <option value="0-10000">Below ₹10,000</option>
          <option value="10000-20000">₹10,000 - ₹20,000</option>
          <option value="20000-30000">₹20,000 - ₹30,000</option>
          <option value="30000-50000">Above ₹30,000</option>
        </select>
      </div>

      {/* ---------------- PRODUCT GRID ---------------- */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {filteredProducts.map((item) => (
          <div
            key={item.id}
            className="border rounded-lg p-3 hover:shadow-md transition"
          >
            <img
              src={item.image}
              alt={item.title}
              className="rounded w-full mb-3"
            />

            <h3 className="font-semibold text-sm mb-1">{item.title}</h3>
            <p className="text-xs text-gray-600">{item.purity}</p>
            <p className="text-red-600 font-bold mt-2">₹{item.price}</p>
          </div>
        ))}
      </div>

      {/* Empty State */}
      {filteredProducts.length === 0 && (
        <p className="text-center text-gray-500 mt-6">No matching products found.</p>
      )}
    </div>
  );
}
